/**
 * Danh sách loại tệp cho `<input type="file" accept>`.
 *
 * Phải TRÙNG KHÍT allowlist của máy chủ (apps/api/src/routes/files.ts). Trước
 * đây mỗi form gõ một chuỗi riêng, và ô ảnh của dòng đơn mẫu dùng `image/*` —
 * rộng hơn máy chủ, nên người dùng chọn được .heic/.bmp rồi mới bị từ chối sau
 * khi tải xong. Một hằng số dùng chung để hai bên không lệch nhau lần nữa.
 */
export const IMAGE_ACCEPT = "image/png,image/jpeg,image/webp,image/gif";

export const DOCUMENT_ACCEPT = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
].join(",");

/** Đính kèm của đơn mẫu nhận cả ảnh lẫn tài liệu. */
export const ATTACHMENT_ACCEPT = `${IMAGE_ACCEPT},${DOCUMENT_ACCEPT}`;
